import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "bg-gray-100 py-12"
}
const _hoisted_2 = { class: "container mx-auto px-4 lg:px-40 max-w-5xl" }
const _hoisted_3 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_4 = { class: "w-full px-2" }
const _hoisted_5 = { class: "text-sm text-red-500 p-error" }
const _hoisted_6 = { class: "flex flex-wrap py-2 mt-3" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_9 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.schema,
        class: "space-y-4 text-gray-700 pb-96"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "font-bold text-gray-800 mb-0 text-2xl text-center pt-5 pb-1" }, " CREDENCIALES DE VISITANTES ", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "text-gray-800 mb-4 text-xl text-center pt-2 pb-5" }, " Complete el siguiente formulario para descargar su credencial ", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[1] || (_cache[1] = _createElementVNode("label", { class: "block mb-1" }, "DNI", -1)),
                _createVNode(_component_Field, {
                  name: "documento",
                  modelValue: _ctx.formData.documento,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.documento) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "numeric",
                      placeholder: "Documento / Pasaporte",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_5, [
                      _createVNode(_component_ErrorMessage, { name: "documento" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "submit",
                label: "REGISTRARME",
                class: "mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_8, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_9, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _cache[2] || (_cache[2] = _createTextVNode("DESCARGAR CREDENCIAL "))
              ], 8, _hoisted_7)
            ])
          ]),
          _createVNode(_component_BlockUI, {
            blocked: _ctx.isSubmitting,
            fullScreen: ""
          }, null, 8, ["blocked"])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ], 64))
}